/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogContent,
  Grid,
  Button,
  TextField,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { FileCopy } from '@material-ui/icons';
import copy from 'copy-to-clipboard';
import { QRCode } from 'react-qrcode-logo';

import { ShareModalContext } from 'common/context';
import logo from 'assets/images/logoIcon.png';

import { useStyles } from './ShareModal.style';

const CustomQRCode = ({ url }) => {
  const classes = useStyles();
  return (
    <div className={classes.qrWrapper}>
      <QRCode value={url} logoImage={logo} size={250} removeQrCodeBehindLogo />
    </div>
  );
};

const ShareModal = () => {
  const {
    selectedCandidate,
    showShareModal,
    handleCloseShareModal,
    selfRequestHandler,
  } = useContext(ShareModalContext);
  const [url, setUrl] = useState('');
  const [urlAnon, setUrlAnon] = useState('');

  const setShareHash = ({ shareHash, shareHashAnon }) => {
    if (shareHash) {
      setUrl(
        `${process.env.REACT_APP_WEB_SOCKET_URL}/passport-share/${shareHash}`,
      );
      setUrlAnon(
        `${process.env.REACT_APP_WEB_SOCKET_URL}/passport-share/${shareHashAnon}`,
      );
    }
  };

  useEffect(() => {
    if (showShareModal) {
      (async () => {
        try {
          const res = await axios.get(
            `/candidate/${selectedCandidate.id}/share-hash`,
          );
          setShareHash(res.data);
        } catch (error) {
          console.error(error);
        }
      })();
    }
  }, [showShareModal]);

  const handleClickGenerateUrl = async () => {
    try {
      const res = await axios.put(
        `/candidate/${selectedCandidate.id}/share-hash`,
      );
      setShareHash(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClickCopy = () => {
    copy(url);
  };

  const handleClickCopyAnon = () => {
    copy(urlAnon);
  };

  return (
    <Dialog open={showShareModal} onClose={handleCloseShareModal}>
      <DialogTitle>Passport Share</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {!url ? (
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleClickGenerateUrl}
                fullWidth
              >
                Generate Public Passport URL
              </Button>
            </Grid>
          ) : (
            <>
              <Grid item xs={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CustomQRCode url={url} />
                    <TextField
                      variant="outlined"
                      label="Public Passport URL"
                      value={url}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                    <Typography variant="caption">
                      Named link: shows the full passport with the candidate&apos;s
                      identity.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleClickCopy}
                      startIcon={<FileCopy />}
                      fullWidth
                    >
                      Copy
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CustomQRCode url={urlAnon} />
                    <TextField
                      variant="outlined"
                      label="Anonymous Passport URL"
                      value={urlAnon}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                    />
                    <Typography variant="caption">
                      Anonymous link: shows the results only, with no identifying
                      details.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleClickCopyAnon}
                      startIcon={<FileCopy />}
                      fullWidth
                    >
                      Copy
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
          {selfRequestHandler && (
            <Grid item xs={12}>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ marginBottom: 8 }}
              >
                Sharing shows the anonymous passport by default. Request full
                access from your sponsor to share your named passport.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  selfRequestHandler();
                  handleCloseShareModal();
                }}
                fullWidth
              >
                Request full passport
              </Button>
            </Grid>
          )}
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleCloseShareModal}
              fullWidth
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ShareModal;
